import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getWelldonePdf } from "../../../api/general";

const Bar = () => {
  const { setAddWelldoneClick, setWelldoneInputValue, welldoneInputValue } =
    useContext(StoreContext);

  const getWelldonePdfMethod = async () => {
    const response = await getWelldonePdf();
    if (response.error) {
      console.log("Aferin pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Aferin pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.welldones}>
        <div className={style.welldonestext}>Aferin</div>
        <Link>
          <img alt="" className={style.welldonesvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setWelldoneInputValue(e.target.value);
          }}
          value={welldoneInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddWelldoneClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Aferin</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getWelldonePdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
